var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"card",staticClass:"card-container"},[_c('div',{ref:"border",staticClass:"card-border"},[_c('div',{staticClass:"img-container"},[_c('img',{ref:"img",attrs:{"src":require('@/assets/projects/' + _vm.image)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }